export { SkyTileDashboardComponent } from './tile-dashboard.component';
export { SkyTileDashboardService } from './tile-dashboard.service';
export { SkyTileDashboardModule } from './tile-dashboard.module';
